export const switchConstants = {
  DEFAULT_STYLE: {
    onColor: '#4FCBB2',
    offColor: '#ddd',
    handleDiameter: 16,
    uncheckedIcon: false,
    checkedIcon: false,
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.6)',
    activeBoxShadow: '0px 0px 1px 5px rgba(0, 0, 0, 0.2)',
    height: 20,
    className: 'react-switch',
  },
  UNCHECKED_ICON_DEFAULT_STYLE: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%',
    fontSize: 15,
    color: '#333333',
  },
  CHECKED_ICON_DEFAULT_STYLE: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    fontSize: 15,
    color: '#333333',
  },
};
